<template>
  <div class="forbid">
    <img v-if="isLimit" class="img-empty icon" src="./assets/empty.png" />
    <IconWait v-else class="icon" :animation="false"></IconWait>
    <p v-for="(item,index) in desc" :key="index">{{item}}</p>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import IconWait from '@/components/materials/IconWait';

@Component({
  components: {
    IconWait,
  },
})
export default class Forbid extends Vue {
  @Prop({
    type: Array,
    default: () => [
      '很抱歉，该课程还在小规模内测阶段',
      '测试完成后将会开放，敬请期待',
    ],
  })
  desc!: string[];

  @Prop({ default: false }) isLimit!: boolean;
}
</script>

<style lang="scss" scoped>
.forbid {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 170px;
  color: #aeaecc;
  font-size: 24px;
  line-height: 1.75;
  .icon {
    margin-bottom: 70px;
  }

  .img-empty {
    width: 402px;
    height: 355px;
  }
}
</style>